import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface User {
  name: string;
  mobile: string;
  email: string;
  role: string;
  token: string;
  company_name: string;
  state: string;
  city: string;
  address: string;
  postal_code: string;
  sheba: string;
  owner_sheba: string;
  wallet: string;
  youtube: string;
  site: string;
  is_block: number;
  active_mobile: number;
  active_email: number;
  active_code: string;
}

export interface Error {
  status: boolean;
  message: string;
}

export interface UserAuthInfo {
  errors: Error;
  user: User;
  isAuthenticated: boolean;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = {} as Error;
  user = {} as User;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object - user login now
   * @returns User
   */
  get currentLoginUser(): User {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    if (JSON.stringify(this.errors) === "{}") {
      this.errors.status = true;
      this.errors.message = "";
    }
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors.status = error.status;
    if(error.message == 'Too Many Attempts.')
    {
      this.errors.message = "در هر 2 دقیقه امکان ارسال یک پیامک میسر می باشد.";
    }
    else
    {
      this.errors.message = error.message;
    }
    if (typeof error.errors !== "undefined") {
      let txt = "";
      const size = Object.keys(error.errors).length;
      if (size > 0) {
        Object.keys(error.errors).forEach(function (key) {
          txt += error.errors[key] + " - ";
        });
        this.errors.message = txt;
      }
    }
  }

  @Mutation
  [Mutations.SET_AUTH](data) {
    this.isAuthenticated = true;
    this.user = data.user;
    localStorage.setItem("currentLoginUser", JSON.stringify(data.user));
    this.errors = {} as Error;
    JwtService.saveToken(data.token);
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = {} as Error;
    JwtService.destroyToken();
  }

  @Action
  [Actions.LOGIN](credentials) {
    return ApiService.post("login", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.SEND_OTP](credentials) {
    return ApiService.post("sendOtp", credentials)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ERROR, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data);
        });
  }

  @Action
  [Actions.REGISTER](credentials) {
    return ApiService.post("register", credentials)
        .then(({ data }) => {
          //this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data);
        });
  }

  @Action
  [Actions.ACTIVE_MOBILE](credentials) {
    return ApiService.post("activeMobile", credentials)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data);
        });
  }

  @Action
  [Actions.RESEND_ACTIVE_CODE](credentials) {
    return ApiService.post("sendActiveCodeMobile", credentials)
        .then(({ data }) => {
          //this.context.commit(Mutations.SET_ERROR, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data);
        });
  }


  @Action
  [Actions.LOGOUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.VERIFY_AUTH](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.post("admin/checkLogin", payload)
        .then(({ data }) => {
          data.token = payload.token;
          this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data);
          this.context.commit(Mutations.PURGE_AUTH);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
